import { BorrowerState } from 'actions/borrower';
import { CoBorrowerState } from 'actions/coBorrower';
import { UnderwritingBorrowerDto, BorrowerOwnership, UnderwritingCoborrowerDto } from 'api/UnderwritingApi';
import { CurrentOwnershipStatus } from 'enums/ApplicationsVariables';
import { getStreetNameFromStreetAddress, getStreetNumberFromStreetAddress } from 'utils/stringUtils';

export const MAP_OWNERSHIP_STATUS = {
  [CurrentOwnershipStatus.OwnWithMortgage]: BorrowerOwnership.Buying,
  [CurrentOwnershipStatus.OwnFreeClear]: BorrowerOwnership.Own,
  [CurrentOwnershipStatus.Rent]: BorrowerOwnership.Rent,
  [CurrentOwnershipStatus.LiveWithParents]: BorrowerOwnership.LiveWithParents,
};

export const prepareBorrowerForUnderwriting = (borrower: BorrowerState): UnderwritingBorrowerDto => {
  return {
    first_name: borrower.firstName,
    last_name: borrower.lastName,
    date_of_birth: borrower.dateOfBirth,
    email: borrower.email?.toLowerCase(),
    street_number: borrower.streetNumber,
    street_name: borrower.streetName,
    city: borrower.city,
    state_or_province: borrower.state,
    zip_or_postal_code: borrower.zip,
    phone: borrower.phone,
    personal_id_number: borrower.personalIdNumber,
    borrower_is_permanent_resident: borrower.permanentResident,
    borrower_prove_eligibility: borrower.eligible,
    possession_check: borrower.possessionCheck,
    borrower_work_order_address_verified: borrower.homeImprovementAddress,
    current_home_ownership: MAP_OWNERSHIP_STATUS[borrower.ownershipStatus!],
    move_in_date: borrower.moveInDate,
    borrower_prefilled_first_name: borrower.prefilledFirstName,
    borrower_prefilled_last_name: borrower.prefilledLastName,
    borrower_prefilled_ssn: borrower.prefilledSsn,
    borrower_prefilled_city: borrower.prefilledCity,
    borrower_prefilled_state: borrower.prefilledState,
    borrower_prefilled_street_address: borrower.prefilledStreetAddress,
    borrower_prefilled_zip_or_postal_code: borrower.prefilledZipOrPostalCode,
    borrower_previous_address: borrower.previousAddress && {
      ...borrower.previousAddress,
      street_name: getStreetNameFromStreetAddress(borrower.previousAddress.street_name as string),
      street_number: getStreetNumberFromStreetAddress(borrower.previousAddress.street_name as string),
    },
    previous_move_in_date: borrower.previousMoveInDate,
  };
};

export const prepareCoBorrowerForUnderwriting = (coBorrower: CoBorrowerState): UnderwritingCoborrowerDto => {
  return {
    first_name: coBorrower.firstName,
    last_name: coBorrower.lastName,
    date_of_birth: coBorrower.dateOfBirth,
    email: coBorrower.email?.toLowerCase(),
    phone: coBorrower.phone,
    personal_id_number: coBorrower.personalIdNumber,
    coborrower_prove_eligibility: coBorrower.eligible,
  };
};
